import { FormattedDate } from 'react-intl';
import React from 'react';
import { parse } from 'date-fns';
import './ScreeningTravellerTitle.scss';
export const ScreeningTravellerTitle = ({ traveller, travellerIndex }) => {
  const dob = parse(traveller.dob, 'dd/MM/yyyy', new Date());
  if (traveller?.first_name) {
    return (
      <h3 className={'screening-traveller-title'}>
        {`Screening for ${traveller.title} ${traveller.first_name} ${
          traveller.last_name
        }`}
        {dob && (
          <span className="traveller-dob">
            (<FormattedDate value={dob} />)
          </span>
        )}
      </h3>
    );
  }
  return <h3>Screening for Adult {travellerIndex}</h3>;
};
